import { postApi, postApiPagination } from "../../../Shared/Services/RestService";
import { PaginationResponse } from "../../../Shared/Pagination/PaginationResponse";
import { JobInvitationResponse } from "../../../InvitatationSystem/Types/InvitationSystemType";
import {
  ActivityEvent,
  CandidateDashboard,
  CandidateDashboardFilter,
  KpiMetrics,
  Opportunity,
  TrackActivityRequest,
} from "../Types/CandidateIntelligenceTypes";

export const searchCandidateDashboard = (filter: CandidateDashboardFilter) => {
  return postApi<CandidateDashboard>("/candidate/dashboard/search", filter);
};

export const getCandidateKpis = (filter: CandidateDashboardFilter) => {
  return postApi<KpiMetrics>("/candidate/dashboard/kpis", filter);
};

export const getCandidateOpportunities = (
  filter: CandidateDashboardFilter,
  page: number = 0,
  size: number = 6
) => {
  return postApiPagination<PaginationResponse<Opportunity>>(
    "/candidate/dashboard/opportunities",
    filter,
    { page, size }
  );
};

export const getCandidateInvitations = (
  status: string = "ALL",
  page: number = 0,
  size: number = 10
) => {
  return postApiPagination<PaginationResponse<JobInvitationResponse>>(
    "/candidate/dashboard/invitations",
    {},
    { status, page, size }
  );
};

export const getCandidateActivity = (
  filter: CandidateDashboardFilter,
  page: number = 0,
  size: number = 15
) => {
  return postApiPagination<PaginationResponse<ActivityEvent>>(
    "/candidate/dashboard/activity",
    filter,
    { page, size }
  );
};

export const trackCandidateActivity = (payload: TrackActivityRequest) => {
  return postApi<null>("/candidate/activity", payload);
};

export const trackRecruiterActivity = (payload: TrackActivityRequest) => {
  return postApi<null>("/recruiter/activity", payload);
};